import api from "./api";

export async function getServiceUsers() {
  try {
    const res = await api.get(`serviceusers`);
    return res;
  } catch (err) {
    throw err;
  }
}

export async function createServiceUser(payload) {
  try {
    const res = await api.post(`serviceusers`, {
      ...payload,
      id: "",
    });
    return res;
  } catch (err) {
    throw err;
  }
}

export async function getServiceUser(id) {
  try {
    const res = await api.get(`serviceusers/${id}`);
    return res;
  } catch (err) {
    throw err;
  }
}

export async function getStaffMembers() {
  try {
    const res = await api.get(`staff`);
    return res;
  } catch (err) {
    throw err;
  }
}

export async function getStaff(id) {
  try {
    const res = await api.get(`staff/${id}`);
    return res;
  } catch (err) {
    throw err;
  }
}

export async function createStaff(payload) {
  try {
    const res = await api.post(`staff`, {
      ...payload,
    });
    return res;
  } catch (err) {
    throw err;
  }
}

export async function updateStaff(payload, id) {
  try {
    const res = await api.put(`staff/${id}`, payload);
    return res;
  } catch (err) {
    throw err;
  }
}

export async function updateServiceUser(payload, id) {
  try {
    const res = await api.put(`serviceusers/${id}`, payload);
    return res;
  } catch (err) {
    throw err;
  }
}

export async function getServiceUserMedicationGroups(id) {
  try {
    console.log("API: Making request to:", `serviceusers/${id}/medication-groups`);
    const res = await api.get(`serviceusers/${id}/medication-groups`);
    console.log("API: Response received:", res);
    return res;
  } catch (err) {
    console.error("API: Error in getServiceUserMedicationGroups:", err);
    console.error("API: Error details:", {
      status: err.response?.status,
      data: err.response?.data,
      message: err.message,
      url: err.config?.url
    });
    throw err;
  }
}

export async function getServiceUserSingleMedicationGroup(id, groupId) {
  try {
    const res = await api.get(
      `serviceusers/${id}/medication-groups/group/${groupId}`
    );
    return res;
  } catch (err) {
    throw err;
  }
}

export async function addServiceUserMedicationGroup(id, payload) {
  try {
    const res = await api.post(`serviceusers/${id}/medication-groups`, payload);
    return res;
  } catch (err) {
    throw err;
  }
}

export async function AddMedicationToGroup(id, groupId, payload) {
  try {
    const res = await api.post(
      `serviceusers/${id}/medication-groups/${groupId}/items`,
      payload
    );
    return res;
  } catch (err) {
    throw err;
  }
}

export async function getServiceUserPRNs(id) {
  try {
    const res = await api.get(`serviceusers/${id}/prns`);
    return res;
  } catch (err) {
    throw err;
  }
}

export async function createPRN(id, payload) {
  try {
    const res = await api.post(`serviceusers/${id}/prns`, payload);
    return res;
  } catch (err) {
    throw err;
  }
}

export async function deletePRN(userId, prnId) {
  try {
    const res = await api.delete(`serviceusers/${userId}/prns/${prnId}`);
    return res;
  } catch (err) {
    throw err;
  }
}
